import * as exFormat from '../../../format';

// ----------------------------------------------------------------------------

function formatFileSummary(fileCount: number, totalSize: number): string {
    return `${fileCount} files (${exFormat.bytes(totalSize, 0)})`;
}

// ----------------------------------------------------------------------------

export default formatFileSummary;
